import { createFileRoute } from '@tanstack/react-router';
import { COMMUNITY_TOPIC_KEYS, type CommunityTopicKey } from '@zoxo/shared';

import { PageContainer } from '../components/layout/page-container';
import { GatePrompt, useActionGate } from '../features/auth/action-gate';
import { PostEditor } from '../features/community/post-editor';

export const Route = createFileRoute('/posts/create')({
  // 로그인 화면 — 세션이 브라우저에만 있다. 서버는 레이아웃만 그린다(docs/SSR.md).
  ssr: false,
  validateSearch: (search): { topic?: CommunityTopicKey } => {
    const t = search.topic;
    return typeof t === 'string' && (COMMUNITY_TOPIC_KEYS as readonly string[]).includes(t) ? { topic: t as CommunityTopicKey } : {};
  },
  component: Page,
});

function Page() {
  const { topic } = Route.useSearch();
  const gate = useActionGate();
  if (gate === 'anonymous' || gate === 'loading') {
    return <PageContainer><GatePrompt status={gate} message="글을 쓰려면 로그인이 필요해요." /></PageContainer>;
  }
  return (
    <PageContainer>
      <h1 className="sr-only">글쓰기</h1>
      <PostEditor initialTopic={topic} />
    </PageContainer>
  );
}
